import { useDispatch, useSelector } from "react-redux";

import MakuleringerFilterForm from "./MakuleringerFilterForm";

import {
  handleChange as handleChangeAction,
  handleChangeAll as handleChangeAllAction,
  handleChangeToInitState as handleChangeToInitStateAction,
} from "../../../actions/handleChangeAction";
import { getMakuleringer as getRapportMakuleringerAction } from "../../../actions/rapporter/makuleringerActions";

function MakuleringerFilterFormContainer(ownProps) {
  const dispatch = useDispatch();
  const makuleringerFilterForm = useSelector(
    (state) => state.forms.makuleringerFilterForm,
  );
  const makuleringerRapport = useSelector(
    (state) => state.rapporter.makuleringerRapport,
  );

  const page =
    makuleringerRapport && makuleringerRapport.page
      ? makuleringerRapport.page
      : 1;
  const pageSize =
    makuleringerRapport && makuleringerRapport.count
      ? makuleringerRapport.count
      : 1;
  const sort = makuleringerRapport && makuleringerRapport.sort;

  return (
    <MakuleringerFilterForm
      {...ownProps}
      makuleringerFilterForm={makuleringerFilterForm}
      handleChange={(variableName, value) =>
        dispatch(
          handleChangeAction(
            "RAPPORT_MAKULERINGER_FILTER_FORM",
            variableName,
            value,
          ),
        )
      }
      handleChangeAll={(reducerName, payload) =>
        dispatch(handleChangeAllAction(reducerName, payload))
      }
      handleChangeToInitState={(actionType) =>
        dispatch(handleChangeToInitStateAction(actionType))
      }
      getRapportMakuleringer={(params) =>
        dispatch(getRapportMakuleringerAction(params, page, pageSize, sort))
      }
    />
  );
}

export default MakuleringerFilterFormContainer;
